import React, { ComponentState, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { ClientService } from "src/services/clientService";
import APP_ROUTES from "src/helper/app-routes";
import { renderErrors } from "src/helper/error-message-helper";
import NotificationManager from "react-notifications/lib/NotificationManager";

import { NichqHeader } from "./Nichq-heads";
import ClientQuestionnaireService from "./functionToSaveQuestionnaireFromPortal";






export const SDQQuestionnaire = ({ SDQ, SDQSpannish, isSpannishVersion, response, interfered, isPrint, questionId, isFromCP, queId, token }) => {
  const { state } = useLocation();
  const selectedClientId = useSelector((state: ComponentState) => state.selectedClientId);
  const navigate = useNavigate();
  const [totalSum, setTotalSum] = useState<any>(0);
  const [EmotionsSymptomsScale, setEmotionsSymptomsScale] = useState(0);
  const [ConductProblemsScale, setConductProblemsTotal] = useState(0);
  const [HyperactivityScale , setHyperactivityTotal ] = useState(0);
  const [PeerProblemsScale, setPeerProblemsTotal] = useState(0);
  const [ProSocialScale, setProSocialScale] = useState(0);
  const [sdq, setSdq] = useState<any[]>([]);
  const [sdqSpannish, setSdqSpannish] = useState<any[]>([]);
  const [parentImpactScale , setParentImpactScale] = useState(0);

  const handleSaveFromPortal = async () => {
          const questionnaire = isSpannishVersion ? sdqSpannish : sdq;
    ClientQuestionnaireService.updatequestionnaireFromPortal(selectedClientId, 0, [...questionnaire], queId, token)
  }

  const handleCompleteFromPortal = async () => {
    try {
      const questionnaire = isSpannishVersion ? sdqSpannish : sdq;
      ClientQuestionnaireService.completeQuestionnaireFromPortal(false, queId, selectedClientId, 0, [...questionnaire],  {isCompleted: true, inProgress: false, sentToClientPortal: null}, token)
    } catch (error) {
      console.error('Error completing client questionnaire:', error);
      NotificationManager.error('Failed to complete client questionnaire');
    }
  };


    const handleSubmit = async () => {
      const questionnaire = isSpannishVersion ? sdqSpannish : sdq;
      await ClientService.insertClientQuestionnaire(
        selectedClientId, 0,
        [...questionnaire],
        questionId
      )
        .then((result:any) => {
          let questionList = result.resultData;
          navigate(APP_ROUTES.QUESTIONNAIRE);
          NotificationManager.success("Add successfully");
        })
        .catch((error) => {
          // setLoading(false);
          renderErrors(error.message);
        });
    };

     const handleRadioChange = (itemId, value) => {
        if(isSpannishVersion) {
                setSdqSpannish(list => list.map((item, i) =>
                    item.id === itemId
                        ? {
                            ...item,
                            value: value
                        }
                        : item
                ));

        }
        else {
                setSdq(list => list.map((item, i) =>
                    item.id === itemId
                        ? {
                            ...item,
                            value: value
                        }
                        : item
                ));
        }
    }


  useEffect(() => {
    setConductProblemsTotal(0);
    setHyperactivityTotal(0);
    setPeerProblemsTotal(0);
    setPeerProblemsTotal(0);
    setProSocialScale(0);

    setTotalSum(0);
    if(!isSpannishVersion) {
        const Sdq = SDQ.map((item) => {
        const foundItem = response.find((i) => i.questionId === item.questionId);
        if (foundItem) {
            if (item.type === "question") {
            if (foundItem.value) {
                return { ...item, isSelected: true, value: foundItem.value };
            } else {
                return { ...item, isSelected: false, value: "" };
            }
            }
            return { ...item, ...foundItem };
        } else {
            return item;
        }
        });

            setSdq(Sdq);
            setSdqSpannish([]);
    }

    else {
        const Sdq = SDQSpannish.map((item) => {
        const foundItem = response.find((i) => i.questionId === item.questionId);
        if (foundItem) {
            if (item.type === "question") {
            if (foundItem.value) {
                return { ...item, isSelected: true, value: foundItem.value };
            } else {
                return { ...item, isSelected: false, value: "" };
            }
            }
            return { ...item, ...foundItem };
        } else {
            return item;
        }
        });
        setSdqSpannish(Sdq);
                    setSdq([]);
    }




  }, [response, isSpannishVersion])

  const getSeverity = (value, ranges) => {
    if (value >= ranges.significant.min) return 'Significant';
    if (value >= ranges.atRisk.min) return 'At-Risk';
    return 'Non-Significant';
  };

  const getEmotionsSeverity = (value) => getSeverity(value, {
    atRisk: { min: 4 },
    significant: { min: 5 }
  });

  const getConductSeverity = (value) => getSeverity(value, {
    atRisk: { min: 3 },
    significant: { min: 4 }
  });

  const getHyperactivitySeverity = (value) => getSeverity(value, {
    atRisk: { min: 6 },
    significant: { min: 7 }
  });

  const getPeerSeverity = (value) => getSeverity(value, {
    atRisk: { min: 3 },
    significant: { min: 4 }
  });

  const getTotalDifficultiesSeverity = (value) => getSeverity(value, {
    atRisk: { min: 14 },
    significant: { min: 17 }
  });

  const getProsocialSeverity = (value) => {
    if (value >= 6) return 'Non-Significant';
    if (value === 5) return 'At-Risk';
    return 'Significant';
  };

  const getParentImpactSeverity = (value) => {
    if (value === 0) return 'Non-Significant';
    if (value === 1) return 'At-Risk';
    return 'Significant';
  };


  useEffect(() => {
  const reverseIds = [7, 11, 14, 21, 25];
  const specialIds = [26, 27, 28, 29, 30, 31, 32, 33];
  const EmotionsSymptomsQues = [3, 8, 13, 16, 24];
  const ConductProblemsTotal = [5, 7, 12, 18, 22];
  const HyperactivityTotal = [2, 10, 15, 21, 25];
  const PeerProblemsTotal = [6, 11, 14, 19, 23];
  const ProsocialScaleTotal = [1, 4, 9, 17, 20];

  const data = isSpannishVersion ? sdqSpannish : sdq;

  const filteredList = data.filter(item => item?.value && (item.id <= 25 || specialIds.includes(item.id)));

  if (!Array.isArray(filteredList)) return;

  // Local scale scores
  let emotions = 0;
  let conduct = 0;
  let hyperactivity = 0;
  let peer = 0;
  let prosocial = 0;
  let total = 0;
  let Parent = 0;

  const getScore = (item) => {
    let score = Number(item.value) || 0;

    if (reverseIds.includes(item.id)) {
      if (score === 0) score = 2;
      else if (score === 2) score = 0;
    } else if (specialIds.includes(item.id)) {
      if (score === 0 || score === 1) score = 0;
      else if (score === 2) score = 1;
      else if (score === 3) score = 2;
    }

    return score;
  };

  filteredList.forEach(item => {
    const score = getScore(item);
    total += score;

    if (EmotionsSymptomsQues.includes(item.id)) emotions += score;
    if (ConductProblemsTotal.includes(item.id)) conduct += score;
    if (HyperactivityTotal.includes(item.id)) hyperactivity += score;
    if (PeerProblemsTotal.includes(item.id)) peer += score;
    if (ProsocialScaleTotal.includes(item.id)) prosocial += score;
    if (specialIds.includes(item.id)) Parent += score;
  });

  // Update state
  setEmotionsSymptomsScale(emotions);
  setProSocialScale(prosocial);
  setConductProblemsTotal(conduct);
  setPeerProblemsTotal(peer);
  setHyperactivityTotal(hyperactivity);
  setParentImpactScale(Parent);
  setTotalSum(total);
}, [sdq, sdqSpannish, isSpannishVersion]);


return (
  <div className="ml-3">
    <div className="mt-5 head-4">
      {isSpannishVersion
        ? 'Cuestionario de capacidades y dificultades (SDQ-Cas)'
        : 'Strengths and Difficulties Questionnaire'}
    </div>

    <div className="row mt-2">
      <p className="mt-1">
        {isSpannishVersion ? (
          <>
            Por favor, ponga una cruz en el cuadro que usted cree que
            corresponde a cada una de las preguntas: No es cierto, Un tanto
            cierto, Absolutamente cierto. Nos sería de gran ayuda si respondiese
            a todas las preguntas lo mejor que pudiera, aunque no esté
            completamente seguro/a de la respuesta, o le parezca una pregunta
            rara. Por favor, responda a las preguntas basándose en el
            comportamiento de su hijo/a durante los últimos seis meses.
          </>
        ) : (
          <>
            For each item, please mark the box for Not True, Somewhat True or
            Certainly True. It would help us if you answered all items as best
            you can even if you are not absolutely certain. Please give your
            answers on the basis of your child's behavior over the last six
            months.
          </>
        )}
      </p>
    </div>

    {/* English Version */}
    {sdq.length > 0 && (
      <div className="row mt-2">
        {sdq.map((item) => {
          const hiddenQues = [
            "SDQ_Q27", "SDQ_Q28", "SDQ_Q29_HomeLife", "SDQ_Q29_Friendships",
            "SDQ_Q29_ClassroomLearning", "SDQ_Q29_LeisureActivities", "SDQ_Q30"
          ];
          const subQues29 = [
            "SDQ_Q29_HomeLife", "SDQ_Q29_Friendships",
            "SDQ_Q29_ClassroomLearning", "SDQ_Q29_LeisureActivities"
          ];
          const q26Answer = sdq.find(i => i.questionId === "SDQ_Q26")?.value;
          if (hiddenQues.includes(item.questionId) && (!q26Answer || q26Answer === "0" || q26Answer === null)) return null;

          return (
            <div
              key={item.id}
              className={item.type === 'radio'
                ? "mb-0 col-lg-12 col-md-6 col-12 printCheckboxSpace"
                : "mb-0 col-lg-4 col-md-6 col-12 printCheckboxSpace"}
            >
              {(item.type === 'question' || item.type === 'date') && (!isFromCP && response?.length > 0) ? (
                <div className="column">
                  <div className="content valueColor fw-600 mb-0 font-12 labelFonts">
                    <label>{item.name}</label>
                  </div>
                  <div className="client-name">
                    <label>{item.value}</label>
                  </div>
                </div>
              ) : item.type === 'radio' ? (
                <div>
                  {item.parentHeader && (
                    <div className="col-12 head-6 mt-3 mb-0">
                      <label>{item.parentHeader}</label>
                    </div>
                  )}
                  <div className="content valueColor fw-600 mb-0 font-12 labelFonts">
                    <label>&nbsp;</label>
                  </div>
                  {(!subQues29.includes(item.questionId) || (item.questionId === "SDQ_Q29_HomeLife")) && 
                  (
                  <div className="client-name">
                    <label>{item.name}</label>
                  </div>
                  )
                  }
                  {(subQues29.includes(item.questionId)) && 
                      (
                        <label className="ml-2 mr-4">{item?.label}</label>
                      )
                  }
                  {item.buttons.map((btn) => (
                    <label key={btn.value} className="fw-400 cats_label">
                      <input
                        type="radio"
                        value={btn.value}
                        checked={item.value === btn.value}
                        onChange={() => handleRadioChange(item.id, btn.value)}
                        className="mr-2 mb-0"
                      />
                      <span>{btn.label}</span>
                    </label>
                  ))}
                </div>
              ) : null}
            </div>
          );
        })}
      </div>
    )}

    {/* Spanish Version */}
    {sdqSpannish.length > 0 && (
      <div className="row mt-2">
        {sdqSpannish.map((item) => {
          const hiddenQues = [
            "SDQSpannish_Q27", "SDQSpannish_Q28", "SDQSpannish_Q29_Hogar", "SDQSpannish_Q29_Amistades",
            "SDQSpannish_Q29_Aprendizaje", "SDQSpannish_Q29_Ocio", "SDQSpannish_Q30"
          ];
          const subQues29 = [
            "SDQSpannish_Q29_Hogar", "SDQSpannish_Q29_Amistades",
            "SDQSpannish_Q29_Aprendizaje", "SDQSpannish_Q29_Ocio"
          ];
          const q26Answer = sdqSpannish.find(i => i.questionId === "SDQSpannish_Q26")?.value;
          if (hiddenQues.includes(item.questionId) && (!q26Answer || q26Answer === "0" || q26Answer === null)) return null;

          return (
            <div
              key={item.id}
              className={item.type === 'radio'
                ? "mb-0 col-lg-12 col-md-6 col-12 printCheckboxSpace"
                : "mb-0 col-lg-4 col-md-6 col-12 printCheckboxSpace"}
            >
              {(item.type === 'question' || item.type === 'date') && (!isFromCP && response?.length > 0) ? (
                <div className="column">
                  <div className="content valueColor fw-600 mb-0 font-12 labelFonts">
                    <label>{item.name}</label>
                  </div>
                  <div className="client-name">
                    <label>{item.value}</label>
                  </div>
                </div>
              ) : item.type === 'radio' ? (
                <div>
                  {item.parentHeader && (
                    <div className="col-12 head-6 mt-3 mb-0">
                      <label>{item.parentHeader}</label>
                    </div>
                  )}
                  <div className="content valueColor fw-600 mb-0 font-12 labelFonts">
                    <label>&nbsp;</label>
                  </div>
                {(!subQues29.includes(item.questionId) || (item.questionId === "SDQSpannish_Q29_Hogar")) && 
                  (
                  <div className="client-name">
                    <label>{item.name}</label>
                  </div>
                  )
                  }
                  {(subQues29.includes(item.questionId)) && 
                      (
                        <label className="ml-2 mr-4">{item?.label}</label>
                      )
                  }
                  {item.buttons.map((btn) => (
                    <label key={btn.value} className="fw-400 cats_label">
                      <input
                        type="radio"
                        value={btn.value}
                        checked={item.value === btn.value}
                        onChange={() => handleRadioChange(item.id, btn.value)}
                        className="mr-2 mb-0"
                      />
                      <span>{btn.label}</span>
                    </label>
                  ))}
                </div>
              ) : null}
            </div>
          );
        })}
      </div>
    )}

  <div className="text-start justify-content-start total_phq col-12 ml-n3 mt-2">
    <label><b>Emotions Symptoms Scale: (Q. 3, 8, 13, 16, 24)</b></label>
    <p className="submit_phq mb-0">
      {(EmotionsSymptomsScale || EmotionsSymptomsScale === 0) 
        ? `${EmotionsSymptomsScale} (${getEmotionsSeverity(EmotionsSymptomsScale)})` 
        : '\u00A0'}
    </p>
  </div>

  <div className="text-start justify-content-start total_phq col-12 ml-n3 mt-2">
    <label><b>Conduct Problems Scale: (Q. 5, 7, 12, 18, 22)</b></label>
    <p className="submit_phq mb-0">
      {(ConductProblemsScale || ConductProblemsScale === 0) 
        ? `${ConductProblemsScale} (${getConductSeverity(ConductProblemsScale)})` 
        : '\u00A0'}
    </p>
  </div>

  <div className="text-start justify-content-start total_phq col-12 ml-n3 mt-2">
    <label><b>Hyperactivity Scale: (Q. 2, 10, 15, 21, 25)</b></label>
    <p className="submit_phq mb-0">
      {(HyperactivityScale || HyperactivityScale === 0) 
        ? `${HyperactivityScale} (${getHyperactivitySeverity(HyperactivityScale)})` 
        : '\u00A0'}
    </p>
  </div>

  <div className="text-start justify-content-start total_phq col-12 ml-n3 mt-2">
    <label><b>Peer Problems Scale: (Q. 6, 11, 14, 19, 23)</b></label>
    <p className="submit_phq mb-0">
      {(PeerProblemsScale || PeerProblemsScale === 0) 
        ? `${PeerProblemsScale} (${getPeerSeverity(PeerProblemsScale)})` 
        : '\u00A0'}
    </p>
  </div>

  <div className="text-start justify-content-start total_phq col-12 ml-n3 mt-2">
    <label><b>Total Difficulties Score (Does not Include Prosocial Scale):</b></label>
    <p className="submit_phq mb-0">
      {(EmotionsSymptomsScale || EmotionsSymptomsScale === 0) &&
      (ConductProblemsScale || ConductProblemsScale === 0) &&
      (HyperactivityScale || HyperactivityScale === 0) &&
      (PeerProblemsScale || PeerProblemsScale === 0)
        ? (() => {
            const total = EmotionsSymptomsScale + ConductProblemsScale + HyperactivityScale + PeerProblemsScale;
            return `${total} (${getTotalDifficultiesSeverity(total)})`;
          })()
        : '\u00A0'}
    </p>
  </div>

  <div className="text-start justify-content-start total_phq col-12 ml-n3 mt-2">
    <label><b>Total Prosocial Score: (Q. 1, 4, 9, 17, 20)</b></label>
    <p className="submit_phq mb-0">
      {(ProSocialScale || ProSocialScale === 0) 
        ? `${ProSocialScale} (${getProsocialSeverity(ProSocialScale)})` 
        : '\u00A0'}
    </p>
  </div>


  <div className="text-start justify-content-start total_phq col-12 ml-n3 mt-2">
    <label><b>Total Parent Impact Score: (Q. 26, 27, 28, 29a, 29b, 29c, 29d, 30)</b></label>
    <p className="submit_phq mb-0">
      {(parentImpactScale || parentImpactScale === 0) 
        ? `${parentImpactScale} (${getParentImpactSeverity(parentImpactScale)})` 
        : '\u00A0'}
    </p>
  </div>


    {/* Action Buttons */}
    {isFromCP ? (
      <div className="text-start mt-3 col-12">
        <button onClick={handleCompleteFromPortal} className="submitButon">
          Save & Complete
        </button>
        <button onClick={handleSaveFromPortal} className="cancelBtn">
          Save progress
        </button>
      </div>
    ) : state == null && !isPrint ? (
      <div className="text-start mt-3 col-12">
        <button onClick={handleSubmit} className="submitButon">
          Submit
        </button>
      </div>
    ) : null}
  </div>
);


}



